/* src/app/components/pages/error-page/error-page.component.sass */
/*# sourceMappingURL=error-page.component.css.map */
